<template>
  <div class="tabsContent1">
    <div class="sta-cav" style="height: 280px;">
      <div class="sta-title">

        <div class="time-con">
          <span>选择时间：</span>
          <el-date-picker
            v-if="sletime==1"
            v-model="time"
            value-format="yyyy"
            style="width: 130px"
            type="year"
            placeholder="选择年">
          </el-date-picker>
          <el-date-picker
            v-model="time"
            v-if="sletime==2"
            value-format="yyyy-MM"
            style="width: 130px"
            type="month"
            placeholder="选择月">
          </el-date-picker>
          <el-date-picker
            v-model="time"
            v-if="sletime==3"
            style="width: 130px"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日">
          </el-date-picker>
          <span class="search-btn" @click="getcavdata()">查询</span>
          <div class="time-type" style="float: right">
            <div class="type-btn " :class="sletime=='3'?'active-btn':''" @click="changesle('3')">
             时
            </div>
            <div class="type-btn" :class="sletime=='2'?'active-btn':''" @click="changesle('2')">
              日
            </div>
            <div class="type-btn" :class="sletime=='1'?'active-btn':''" @click="changesle('1')">
              月
            </div>

          </div>


        </div>
        <div class="change-item">
          <div class="item-tab">
            <div class="type-con" :class="itemType=='ElectricalFire'?'active-con':''" @click="changeitem('ElectricalFire')">
              电气火灾风险指数
            </div>
            <div v-show="istwo=='2'" class="type-con" :class="itemType=='InsulationConductivity'?'active-con':''" @click="changeitem('InsulationConductivity')">
              绝缘老化风险指数
            </div>
            <div class="color-list" v-if="itemType=='ElectricalFire'">
              <span class="out-cir">
                <span class="cir-fang green-one-bk">

                </span>
                <span>
                  < {{ topdatamform.residualCurrentA }}
                </span>
              </span>
              <span class="out-cir">
                <span class="cir-fang yel-one-bk">

                </span>
                <span>
                  {{ topdatamform.residualCurrentA }}  -  {{ topdatamform.residualCurrentB }}
                </span>
              </span>
              <span class="out-cir">
                <span class="cir-fang org-one-bk">

                </span>
                <span>
                 {{ topdatamform.residualCurrentB }}  -  {{ topdatamform.residualCurrentC }}
                </span>
              </span>
              <span class="out-cir">
                <span class="cir-fang red-one-bk">

                </span>
                <span>
                   > {{ topdatamform.residualCurrentC }}
                </span>
              </span>
            </div>
            <div class="color-list" v-if="itemType=='InsulationConductivity'">
              <span class="out-cir">
                <span class="cir-fang green-one-bk">

                </span>
                <span>
                  < {{ topdatamform.insulationResistanceA }}
                </span>
              </span>
              <span class="out-cir">
                <span class="cir-fang yel-one-bk">

                </span>
                <span>
                  {{ topdatamform.insulationResistanceA }}  -  {{ topdatamform.insulationResistanceB }}
                </span>
              </span>
              <span class="out-cir">
                <span class="cir-fang org-one-bk">

                </span>
                <span>
                 {{ topdatamform.insulationResistanceB }}  -  {{ topdatamform.insulationResistanceC }}
                </span>
              </span>
              <span class="out-cir">
                <span class="cir-fang red-one-bk">

                </span>
                <span>
                   > {{ topdatamform.insulationResistanceC }}
                </span>
              </span>
            </div>
          </div>
          <div class="bom-cav" id="eleNum">

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Axios from "@/utils/Axios";
import Axios2 from "@/utils/Axios2";

import Vue from "vue";

import qs from "qs";
export default {
  name: "tabsContent1",
  data() {
    return {
      year:"",
      month:"",
      hour:"",

      time:"",
      sletime:"3",
      partype:"",
      itemType:"ElectricalFire",
      saveid:"",
      istwo:"",
      cavtitle:"",
      cavdata:[],
      branchId:null,
      topdatamform: {
        insulationResistanceA: "",
        insulationResistanceB: "",
        insulationResistanceC: "",
        residualCurrentA: "",
        residualCurrentB: "",
        residualCurrentC:"",
      },

    };
  },
  mounted() {

    this.saveid=sessionStorage.getItem('saveid');
    this.branchId=sessionStorage.getItem('branchId');
    this.getnowtime()
    this.gettopitem()
    this.getcavdata()
    this.showtopdata()
  },
  methods: {
    //获得实时数据
    getnow(data){

      let that = this;
      let param = {};
      param.method="post";
      param.url="/msg/query/realtime";
      param.data=
        {
          address:data.addr485,

          topic:data.hostTerminalImei,
        }
      Axios2.ajax(param).then((res)=>{

        if(res.status=='200'){
          this.$message({
            type: 'success',
            message: '查询成功!'
          });
          this.getTableData()
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          });
        }

      })
    },
    //获取阈值
    showtopdata(data){
      let that = this;

      let param = {};
      param.method="post";
      param.url="/branch/threshold/"+this.branchId;
      param.data=qs.stringify({
        "branchId":this.branchId,
      })
      Axios.ajax(param).then((res)=>{

        if(res.data){

          this.topdatamform=res.data

        }

      })

    },
    changeitem(data){
      this.itemType=data
      this.getcavdata()
    },
    getnowtime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期

      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      var MS = now.getMilliseconds(); //获取毫秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      if (MS < 100) MS = "0" + MS;

      var time = "";
      time =
        year + "-" + month + "-" + date ;
      this.year=year
      this.month=year + "-" + month
      this.hour=time
      this.time = time;
    },
    changesle(data){
      this.sletime=data
      let type
      if(data=='1'){
        type='Month'
        this.time=this.year
      }else if(data=='2'){
        type='Day'
        this.time=this.month
      }else if(data=='3'){
        type='Hour'
        this.time=this.hour
      }
      this.partype=type
      this.getcavdata()
    },
    getdata(){

    },
    gettopitem(){

      let that = this;
      let param = {};
      param.method="post";
      param.url="/monitorBoard/monitorSafeRiskDataParam";
      param.data=qs.stringify({
        monitorSiteId:this.saveid,

      })
      Axios.ajax(param).then((res)=>{
        if(res.data){
          this.istwo=res.data.length
        }


      })
    },
    getcavdata(){
      let that = this;
      let param = {};
      let arrdata=this.itemType
      param.method="post";
      if(this.sletime=='3'){
        param.url="/analogData/hourFreezeDataInfoV2";
      }else   if(this.sletime=='2'){
        param.url="/analogData/dayFreezeDataInfoV2";
      }else   if(this.sletime=='1'){
        param.url="/analogData/monthFreezeDataInfoV2";
      }


      param.data=qs.stringify({
        "monitorSiteId":this.saveid,
        "params":[arrdata],
        "searchDate":this.time

      })
      Axios.ajax(param).then((res)=>{

        let levlist=[]
        this.cavdata=[]
        if(res.data){
          this.cavtitle=res.data.freezeDatas[0]
          for(let i=1;i<res.data.freezeDatas.length;i++){
            this.cavdata.push(res.data.freezeDatas[i])
            levlist.push(res.data.checkSafeDatas[i])
          }
          this.drewcav(this.cavtitle[1],this.cavdata,levlist)
        }

      })
    },
    drewcav(title,data,levlist){
      let xdata=[]
      let ydata=[]
      let levdata=[]
      let series=[]
      for(let i=0;i<data.length;i++){
        xdata.push(data[i][0])
        ydata.push(data[i][1])
        levdata.push(levlist[i][1])
      }
      let colorlist=[['#248ff7','#6851f1'],['#febe13','#65e5dd'],['#f071ff', '#85f67a']]


      let myChart =this.$echarts.init(document.getElementById("eleNum"));
      myChart.clear()
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          right: '10%',
          bottom: '3%',
          left: '6%',
          top: '20px',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: xdata,
            axisLine: {
              lineStyle: {
                color: '#0B4CA9'
              }
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#000",
                fontSize: 12,
              },
              //interval:0,
              //rotate:30
            },
          }],
        yAxis: [
          {
            type: 'value',

            nameTextStyle: {
              color: '#000'
            },
            position: 'left',
            minInterval: 1,
            axisLine: {
              lineStyle: {
                color: '#0B4CA9'
              }
            },
            splitLine: {
              show:false,
              lineStyle: {
                color: "#0B4CA9",
              }

            },
            axisLabel: {
              color: '#000',
              fontSize: 12,
            }
          },
        ],
        series:   {
          name: title,
          type: 'bar',
          barWidth: '10px',
          itemStyle: {
            normal: {
              color:function(params){

                let color=""
                if(levdata[params.dataIndex]=='1'){
                  color="#19AF23"
                }else if(levdata[params.dataIndex]=='2'){
                  color="#FADB14"
                }else if(levdata[params.dataIndex]=='3'){
                  color="#FFA940"
                }else if(levdata[params.dataIndex]=='4'){
                  color="#D61E1E"
                }
                return color
              },
              barBorderRadius: 11,
            }
          },
          data:ydata
        },
      };
      myChart.setOption(option,true);

      window.onresize = myChart.resize;
    },
  },
  watch: {
  },
  components: {}
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
.tabsContent1{
  height: 100%;
}.sta-cav{
   height:280px;
   min-width: 1400px;
   overflow: auto;
   padding-left: 30px;
 }
.color-list{
  display: inline-block;
  margin-left: 80px;
  .out-cir{
    margin-right:10px;
  }
  .cir-fang{
    display: inline-block;
    width: 10px;
    height: 10px;

  }
}
.sta-title{
  font-size: 16px;

  height: 50px;
  line-height: 50px;

  .time-select{
    float: right;
    margin-right: 40px;
  }
  .font-sp{
    font-weight: bold;
    display: inline-block;
    vertical-align: top;
  }
}
.type-btn{
  display: inline-block;
  width: 74px;
  height: 30px;
  text-align: center;

  line-height: 30px;
  margin-right: 20px;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #5780fa;
  color: #5780fa;
}
.active-btn{
  background-color: #5780fa;
  color: #fff;
}
.green-bk{
  background-color: rgba(20, 255, 20, 0.4);
}
.green-one-bk{
  background-color: rgba(20, 255, 20,1);
}
.yel-bk{
  background-color: rgba(255, 255, 0, 0.4);
}
.yel-one-bk{
  background-color: rgba(255, 255, 0, 1);
}
.org-bk{
  background-color: rgba(255, 153, 0, 0.4);
}
.org-one-bk{
  background-color: rgba(255, 153, 0, 1);
}
.red-bk{
  background-color: rgba(247, 20, 20, 0.4);
}
.red-one-bk{
  background-color: rgba(247, 20, 20,1);
}
.time-con{
  display: inline-block;
  vertical-align: top;
  float: right;
  .time-type{
    margin-left: 60px;
  }
}
.search-btn{
  display: inline-block;
  //width: 56px;
  padding: 0 10px;
  height: 28px;
  text-align: center;
  background-color: #5780fa;
  color: #fff;
  line-height: 28px;
  margin-left: 20px;
  border-radius: 4px;
  cursor: pointer;
}

.item-tab{
  .type-con{
    margin-top: 10px;
    display: inline-block;
    color: #000;
    padding: 2px 10px;
    background: #f6f8ff;
    border: 1px solid #ddd;
    margin-right: 10px;
    cursor: pointer;
    height: 30px;
    line-height: 30px;

  }
  .active-con{
    background: #1ab394;
    border: 1px solid #10a7ab;
    color: #fff;
  }
}
#eleNum{

  width: 1400px;
  height: 200px;

}
</style>

